module.exports = __webpack_public_path__ + "static/media/cases_brand_midias_banco.c9f654d7.jpg";